export default __webpack_public_path__ + "static/media/DDD-Labs.d55e4c69.jpg";